var landingPage = document.querySelector("body.page-template-landing");
var landingPageCastle = document.querySelector(
  "body.page-template-landing-castle"
);
var landingB2b = document.querySelector("body.page-template-landing-b2b");

/*
 * B2B Landing Page
 */
if (landingB2b) {
  const statsNumberWrapper = document.querySelector(".stats__numbers-wrapper");

  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight)
    );
  }

  function handleScroll() {
    if (isElementInViewport(statsNumberWrapper) && statsNumberWrapper) {
      statsNumberWrapper.classList.add("active");
      window.removeEventListener("scroll", handleScroll);
    }
  }

  window.addEventListener("scroll", handleScroll);
}

/*
 * Regular Landing Page
 */
if (landingPage) {
}

/*
 * Castle Event Landing Page
 */
if (landingPageCastle) {
  document.addEventListener("DOMContentLoaded", function () {
    //Store lot_id GET param in sessionStorage
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let lotId = urlParams.get("lot_id");

    setTimeout(() => {
      if (window.location.hash === "#form") {
        var formElement = document.getElementById("form");
        if (formElement) {
          formElement.scrollIntoView({ behavior: "smooth" });
        }
      }
    }, 1000);

    if (lotId) {
      const lastChar = lotId[lotId.length - 1];

      if (lastChar.toLowerCase() != lastChar.toUpperCase()) {
        lotId = lotId.slice(0, -1);
      }
      sessionStorage.setItem("traceability_lot_id", lotId);
    }

    const form = document.getElementById("newsletter") as HTMLFormElement;
    form?.addEventListener("submit", (event) => {
      event.preventDefault();

      const submitBtn = document.getElementById("submit");
      const ajaxData = (window as any).njamito_ajax;
      const email = document.getElementById("email") as HTMLInputElement;

      if (submitBtn) {
        submitBtn.classList.add("loading");
        submitBtn.setAttribute("disabled", "true");
      }

      if ((window as any).njamito_ajax) {
        let data = new FormData();
        data.append("action", "njamito_create_omnisend_contact");
        data.append("email", email.value);
        data.append("eventName", "prelaunch-waitlist");
        data.append("nonce", ajaxData.nonce);

        fetch(ajaxData.ajax_url, {
          method: "POST",
          body: data,
        })
          .then((response) => {
            return response.json();
          })
          .then((jsonResponse) => {
            if (!jsonResponse.success) {
            }

            if (jsonResponse.success) {
              form.remove();

              const successMsg = document.querySelector(
                ".product-newsletter__success-message"
              ) as HTMLElement;

              if (successMsg) {
                successMsg.style.display = "block";
              }
            }
          });
      }
    });
  });
}
